export const DEFAULT_PROMO_CODE_KITS = "KITSPS2";
